var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('span',{staticClass:"home",on:{"click":_vm.jump}},[_vm._v("首页")]),_c('span',{staticClass:"home"},[_vm._v("   /  ")]),_c('span',{staticClass:"current-route"},[_vm._v(_vm._s(_vm.pageName))])])}
var staticRenderFns = []

export { render, staticRenderFns }